const { default: axiosIns } = require('@/libs/axios')

const NativeAdTemplatesService = {
  // GET - NativeAdTempalteApiController
  async getNativeAdTemplates(accountId) {
    return axiosIns.get(`/nativeadstemplates?accountId=${accountId}`).then(response => response.data)
  },
  async getTemplate(id, accountId) {
    return axiosIns.get(`/nativeadstemplates/${id}?accountId=${accountId}`).then(response => response.data)
  },
  // POST - NativeAdTempalteApiController
  async saveTemplate(model, accountId) {
    return axiosIns.post(`nativeadstemplates?accountId=${accountId}`, model).then(response => response.data)
  },
}

export default NativeAdTemplatesService
